<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Faktury</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Faktury</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span :class="chevronFiltersClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content flex" v-show="isFiltersOpen">
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <label class="control-label col-sm-3">Wybierz daty</label>
                <div class="col-sm-8">
                  <VueDatePicker
                    class="stats-daterangepicker2"
                    v-model="filterRangeDate"
                    multi-calendars
                    :format="format"
                    range
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2 nopadding">
              <div class="form-group">
                <div class="col-sm-10">
                  <label class="control-label">Rodzaj faktury</label>
                  <Multiselect
                    v-model="filtersInvoice"
                    mode="tags"
                    placeholder="Rodzaj faktury"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="filterOptions"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
            <div class="col-md-2 nopadding">
              <div class="form-group">
                <div class="col-sm-10">
                  <label class="control-label">Status KSeF</label>
                  <Multiselect
                    v-model="filterKsefStatus"
                    mode="single"
                    placeholder="Status KSeF"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="ksefStatusOptions"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <div class="col-sm-10">
                  <label class="control-label">Numer KSeF</label>
                  <input
                    class="form-control inputClass"
                    type="text"
                    v-model="filterKsefNumber"
                    @keyup="searchKsefNumber"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2 nopadding">
              <div
                class="form-group"
                title="Faktury zaliczkowe bez końcowych w tym samym miesiącu"
              >
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        id="without_final"
                        name="without_final"
                        type="checkbox"
                        v-model="final"
                      />
                      <span>
                        Faktury zaliczkowe bez końcowych w tym samym miesiącu
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Faktury</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <box-actions>
              <button @click="download('CSV')" class="btn btn-sm btn-primary">
                <span>
                  <span>Pobierz CSV</span>
                </span>
              </button>
              <button @click="download('JPK')" class="btn btn-sm btn-primary">
                <span>
                  <span>Pobierz JPK_FA</span>
                </span>
              </button>
            </box-actions>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @click="isSearch = false"
                      @change="setRowsPerPage"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model.number="serverOptions.page"
                      @change="
                        serverOptions.page = clampPage(serverOptions.page)
                      "
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="selectPage(serverOptions.page - 1)"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="selectPage(serverOptions.page + 1)"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  alternating
                  multi-sort
                  show-index
                  border-cell
                  @update-sort="updateSort"
                  :body-row-class-name="bodyRowClassNameFunction"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #item-client_email="item">
                    <router-link
                      v-if="canViewClients"
                      :to="'/clients/' + item.client_pk"
                    >
                      {{ item.client_email }}
                    </router-link>
                    <span v-else>{{ item.client_email }}</span>
                  </template>
                  <template #item-actions="item">
                    <button
                      @click="getInvoicePdf(item)"
                      class="btn btn-primary btn-xs"
                      title="Pobierz PDF"
                    >
                      <i class="fa fa-file"></i>
                    </button>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model.number="serverOptions.page"
                      @change="
                        serverOptions.page = clampPage(serverOptions.page)
                      "
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="selectPage(serverOptions.page - 1)"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="selectPage(serverOptions.page + 1)"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="ibox float-e-margins">
                  <div
                    class="ibox-title"
                    @click="isSummaryOpen = !isSummaryOpen"
                  >
                    <h5>Podsumowanie</h5>
                    <span
                      :class="chevronSummaryClass"
                      class="ibox-toggle"
                    ></span>
                  </div>
                  <div class="ibox-content" v-show="isSummaryOpen">
                    <div class="row">
                      <div v-if="summary !== 0" class="col-sm-12 m-b-xs">
                        <EasyDataTable
                          :headers="headers"
                          :items="summary"
                          border-cell
                          hide-footer="true"
                        >
                        </EasyDataTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { hasPermission } from "../../permissions";
import { clientPermissionsConst } from "../../constants/clientConstants";

export default {
  name: "InvoicesList",
  mixins: [],
  components: {
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    const invoicesData = computed(() => store.getters.getInvoicesData);
    // The client column links to the client details view.
    const canViewClients = computed(() =>
      hasPermission(clientPermissionsConst.view)
    );

    let headers = [
      { text: "Nr faktury", value: "number", sortable: true, search: true },
      { text: "Nr zamówienia", value: "order", sortable: true, search: true },
      { text: "Email", value: "client_email", sortable: true, search: true },
      {
        text: "Nazwa firmy",
        value: "company_name",
        sortable: true,
        search: true,
      },
      {
        text: "Sklep",
        value: "company_localization_display",
        sortable: true,
        search: true,
      },
      { text: "Język", value: "lang_display", sortable: true, search: true },
      { text: "Waluta", value: "currency", sortable: true, search: true },
      { text: "Netto", value: "net_price", sortable: true, search: false },
      { text: "VAT", value: "vat", sortable: true, search: false },
      { text: "Brutto", value: "gross_price", sortable: true, search: false },
      {
        text: "Rodzaj faktury",
        value: "invoice_type_display",
        sortable: true,
        search: false,
      },
      {
        text: "Data wystawienia",
        value: "issue_date",
        sortable: true,
        search: true,
      },
      { text: "Data dodania", value: "date_added", sortable: false },
      { text: "Data modyfikacji", value: "date_modified", sortable: false },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: false,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: false,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const filtersMonth = ref();
    const filterRangeDate = ref();
    const final = ref(false);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });
    const summary = ref([]);
    const filtersInvoice = ref();
    const isFiltersOpen = ref(true);
    const isMainOpen = ref(true);
    const isSummaryOpen = ref(true);

    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronSummaryClass = computed(() =>
      isSummaryOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const filterOptions = ref([
      { name: "Końcowa", value: "final_invoice" },
      { name: "Zaliczkowa", value: "advance_invoice" },
      { name: "Proforma", value: "proforma_invoice" },
      { name: "Nieopłacona", value: "deadline" },
    ]);

    const ksefStatusOptions = ref([]);
    const filterKsefStatus = ref(null);
    const filterKsefNumber = ref("");
    let ksefNumberTimeout = null;

    const ksefInvoiceStatusOpts = computed(
      () => store.getters.getKsefInvoiceStatusOpts
    );

    const getInvoices = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getInvoices", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        date: filterRangeDate.value,
        filters: filtersInvoice.value,
        final: final.value,
        ksefStatus: filterKsefStatus.value,
        ksefNumber: filterKsefNumber.value,
      });
    };

    const searchKsefNumber = () => {
      clearTimeout(ksefNumberTimeout);
      ksefNumberTimeout = setTimeout(() => {
        selectPage(1);
        getInvoices();
      }, 1000);
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getInvoices();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      filterRangeDate.value = [];
      serverOptions.value.sortBy = "";
      filterKsefStatus.value = null;
      filterKsefNumber.value = "";
      getInvoices();
    };

    const updateSort = () => {
      search.value = true;
    };

    const bodyRowClassNameFunction = (item) => {
      if (item.exposing_value) {
        return item.exposing_value;
      }

      return false;
    };

    const getInvoicePdf = (item) => {
      store.dispatch("getInvoicePdf", {
        pk: item.order,
        type: item.invoice_type,
      });
    };

    const format = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    const download = (type) => {
      if (filtersMonth.value) {
        if (type === "CSV") {
          store.dispatch("invoiceExportCSV", {
            month: filtersMonth.value.month + 1,
            year: filtersMonth.value.year,
            type: "admin_export_csv",
          });
        } else if (type === "JPK") {
          store.dispatch("invoiceExportCSV", {
            month: filtersMonth.value.month + 1,
            year: filtersMonth.value.year,
            type: "admin_export_jpkfa",
          });
        }
      } else {
        store.dispatch("showToaster", {
          type: "error",
          content: "Wybierz miesiąc aby pobrać plik!",
        });
      }
    };

    const tableSummary = () => {
      let tempSummary = {
        net_price: 0,
        vat: 0,
        gross_price: 0,
      };
      summary.value = [];
      items.value?.forEach((element) => {
        tempSummary.net_price += Math.round(element.net_price);
        tempSummary.vat += Math.round(element.vat);
        tempSummary.gross_price += Math.round(element.gross_price);
      });
      summary.value.push(tempSummary);
    };

    const getMaxPages = () => {
      const total = Number(itemsAll.value) || 0;
      const perPage = Number(serverOptions.value.rowsPerPage) || 1;
      return Math.max(1, Math.ceil(total / perPage));
    };

    const clampPage = (page) => {
      const max = getMaxPages();
      if (!page || Number.isNaN(Number(page))) return 1;
      return Math.min(Math.max(1, Number(page)), max);
    };

    const selectPage = (page) => {
      serverOptions.value.page = clampPage(page);
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("invoicesSearchValue") !== null) {
        searchValue.value = localStorage.getItem("invoicesSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }

      if (
        localStorage.getItem("invoicesRangeDate") !== null &&
        localStorage.getItem("invoicesRangeDate") !== undefined
      ) {
        filterRangeDate.value = localStorage.getItem("invoicesRangeDate");
        filterRangeDate.value = JSON.parse(filterRangeDate.value);
      }

      store.dispatch("getKsefInvoiceStatusOpts");
      getInvoices();
    });

    watch(
      () => [searchValue.value, filterRangeDate.value],
      function () {
        localStorage.setItem(
          "invoicesSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "invoicesRangeDate",
          JSON.stringify(filterRangeDate.value)
        );
        getInvoices();
      }
    );

    watch(
      () => filtersMonth.value,
      function () {
        getInvoices();
      }
    );
    watch(
      () => filtersInvoice.value,
      function () {
        getInvoices();
      }
    );
    watch(
      () => final.value,
      function () {
        getInvoices();
      }
    );
    watch(
      () => filterKsefStatus.value,
      function () {
        selectPage(1);
        getInvoices();
      }
    );

    watch(
      () => ksefInvoiceStatusOpts.value,
      function (newValue) {
        if (newValue && newValue.status === 200) {
          ksefStatusOptions.value = newValue.data || [];
        }
      }
    );

    watch(
      () => invoicesData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;

        tableSummary();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getInvoices();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      items,
      itemsAll,
      loading,
      canViewClients,
      serverOptions,
      showModal,
      searchValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      bodyRowClassNameFunction,
      getInvoicePdf,
      format,
      filtersMonth,
      filterRangeDate,
      download,
      summary,
      filterOptions,
      filtersInvoice,
      final,
      ksefStatusOptions,
      filterKsefStatus,
      filterKsefNumber,
      searchKsefNumber,
      selectPage,
      clampPage,
      getMaxPages,
      setRowsPerPage,
      isFiltersOpen,
      isMainOpen,
      isSummaryOpen,
      chevronFiltersClass,
      chevronMainClass,
      chevronSummaryClass,
    };
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}
</style>
